module.exports = __webpack_public_path__ + "img/农机贷（对公）.a84a72f2.png";